module.exports = __webpack_public_path__ + "img/chlorophilia-identidad-12.3dad1d62.jpg";